import { Chip } from '@mui/material';

// Status → label + tinted colors, matching the validated NPC Log prototype.
export const NPC_STATUS: Record<string, { label: string; fg: string; bg: string }> = {
  NOT_VALIDATED: { label: 'Not Validated', fg: '#B54708', bg: '#FEF0C7' },
  APPROVED: { label: 'Approved', fg: '#0E9384', bg: '#E4F8F3' },
  DECLINED: { label: 'Declined', fg: '#B42318', bg: '#FEE4E2' },
};

export const StatusPill = ({ status }: { status: string }) => {
  const s = NPC_STATUS[status] || { label: status, fg: '#374151', bg: '#F2F4F7' };
  return (
    <Chip
      label={s.label}
      size="small"
      sx={{
        bgcolor: s.bg,
        color: s.fg,
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: '.4px',
        textTransform: 'uppercase',
        borderRadius: '8px',
        height: 24,
      }}
    />
  );
};
